// @core/api/endpoints/task/list_task_categories.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTaskCategoriesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List task categories
 * Returns task categories, optionally filtered by parent.
 */
export async function ListTaskCategories(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTaskCategoriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-categories`;
  const requestOptions = options;
  return client.get<ListTaskCategoriesResponse>(requestPath, { ...requestOptions, params });
}
